/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-12-01T19:13:36.444
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listConDeputeContractBackSettlementItem,
	listConDeputeContractBackSettlementItemInit,
	listConDeputeContractBackSettlementItemByAuthorizations,
	deleteConDeputeContractBackSettlementItem
} from '@api/storagemanage/ConDeputeContractBackSettlementItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listConDeputeContractBackSettlementItem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listConDeputeContractBackSettlementItem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listConDeputeContractBackSettlementItemByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listConDeputeContractBackSettlementItemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listConDeputeContractBackSettlementItemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listConDeputeContractBackSettlementItemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						state.CompoundEntities.rowFunctionAuthorization = res.rowFunctionAuthorization;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteConDeputeContractBackSettlementItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteConDeputeContractBackSettlementItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
